import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'push'
})
export class PushPipe implements PipeTransform {

  transform(array_: any[] | any, item?:any, key= 'id'): any[] {
    const array = [...array_];
    if(item && Array.isArray(array) &&
      (!array.find(i => i?.[key] === item?.[key]) || !array.find(i => i === item))) {
      array.push(item);
    }
    return  array;
  }
}

